import { assertUnreachable } from './tsUtils';
export const TOURNEY_CHIP_CHAR = '⌾';
export function getCurrencyAmountString(amount, currency, showJacksLabel = true) {
    switch (currency) {
        case 'chips': {
            return `$${amount.toLocaleString()}`;
        }
        case 'jacks': {
            if (!showJacksLabel) {
                return amount.toLocaleString();
            }
            return `${amount.toLocaleString()} Jack${amount !== 1 ? 's' : ''}`;
        }
        default: {
            assertUnreachable(currency);
        }
    }
}
